import { render, staticRenderFns } from "./FairAppModule.vue?vue&type=template&id=21a24370&scoped=true"
import script from "./FairAppModule.vue?vue&type=script&lang=js"
export * from "./FairAppModule.vue?vue&type=script&lang=js"
import style0 from "./FairAppModule.vue?vue&type=style&index=0&id=21a24370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a24370",
  null
  
)

export default component.exports